import * as React from 'react'
import Navigation from '../../components/Messenger/Navigation'
import styled from 'styled-components'
import { Route, RouteComponentProps, Switch } from 'react-router';
import ERoute from '../../ERoute';
import HelpCollection from './HelpCollection';
import HelpOverview from './HelpOverview';
import CloseButton from '../../components/Messenger/Navigation/CloseButton';
import Search from '../../components/Help/Search';
import SearchResults from '../../components/Help/SearchResults';
import { WithTranslation, withTranslation } from 'react-i18next';
import FadeInContainer from '../../components/Messenger/Animation/FadeInContainer';
import ScrollToTopOnMount from '../../effects/ScrollToTopOnMount';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
`

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column; 
  flex: 1;
`

export interface HelpParams {
  focusSearch?: string
}

type IProps = RouteComponentProps<HelpParams> & WithTranslation
interface IState { }

class Help extends React.Component<IProps, IState> {
  private searchInput: React.RefObject<HTMLInputElement> = React.createRef()

  componentDidMount(): void {
    setTimeout(() => {
      this.processParams()
    }, 150)
  }

  processParams = () => {
    const { match: { params }, location: { search } } = this.props
    const searchParams = new URLSearchParams(search);

    if (searchParams.get('focusSearch') && this.searchInput.current) {
      this.searchInput.current?.focus()
    }
  }

  componentDidUpdate(prevProps: IProps, prevState: IState, snapshot?: any): void {
    if (this.props.match.params !== prevProps.match.params) {
      this.processParams()
    }
  }

  render() {
    const { t } = this.props

    return (
      <FadeInContainer>
        <Container>
          <Navigation
            title={t('Help::Help')}
            bottom={<Search />}
            right={<CloseButton />}
          />
          <ScrollToTopOnMount />

          <Wrapper>
            <SearchResults />

            <Switch>
              <Route path={ERoute.PATH_HELP_COLLECTION} component={HelpCollection} />
              <Route path={ERoute.PATH_HELP} component={HelpOverview} />
            </Switch>
          </Wrapper>
        </Container>
      </FadeInContainer>
    )
  }
}

export default withTranslation()(Help)